// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ================================
   Announcements Floating Widget
   (Clean version: no duplicates)
   ================================ */

/* Floating container (bottom-right) */
.afw-container {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 1200;
  font-family: inherit;
}

/* Floating button */
.afw-button {
  width: 56px;
  height: 56px;
  border-radius: 999px;
  background: #0f174f;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 18px rgba(15, 23, 79, 0.25);
  cursor: pointer;
  position: relative;
}

/* Badge (unread count) */
.afw-badge {
  position: absolute;
  top: -6px;
  right: -6px;
  background: #e65c1c;
  color: white;
  font-size: 12px;
  padding: 3px 6px;
  border-radius: 999px;
}

/* Panel */
.afw-panel {
  width: min(420px, calc(100vw - 40px));
  max-width: calc(100vw - 32px);
  background: white;
  border-radius: 12px;
  box-shadow: 0 12px 40px rgba(2, 6, 23, 0.4);
  margin-bottom: 12px;

  transform-origin: bottom right;
  transition: transform 180ms ease, opacity 180ms ease;
  opacity: 0;
  transform: scale(0.95) translateY(10px);
  pointer-events: none;

  max-height: calc(100vh - 120px);
  overflow: hidden;
  z-index: 1300;
}

.afw-open .afw-panel {
  opacity: 1;
  transform: scale(1) translateY(0);
  pointer-events: auto;
}

/* Panel header */
.afw-panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 14px;
  border-bottom: 1px solid #eef2f6;
}

.afw-actions {
  display: flex;
  gap: 8px;
  align-items: center;
}

.afw-action {
  background: none;
  border: none;
  padding: 6px 8px;
  border-radius: 6px;
  cursor: pointer;
}

.afw-close {
  background: none;
  border: none;
  font-size: 14px;
  padding: 6px 8px;
  cursor: pointer;
}

/* Panel body */
.afw-panel-body {
  max-height: calc(100vh - 200px);
  overflow: auto;
  padding: 12px;
  -webkit-overflow-scrolling: touch;
}

.afw-empty,
.afw-error {
  color: #6b7280;
  padding: 16px;
  text-align: center;
}

/* List */
.afw-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Item card */
.afw-item {
  background: #f8fafc;
  border-radius: 8px;
  padding: 10px;
  border: 1px solid #eef2f6;
}

/* Read / Unread state */
.afw-unread {
  border: 2px solid #e2520f;
}

.afw-read {
  opacity: 0.7;
  border-left: 3px solid transparent;
}

/* ================================
   ITEM LAYOUT (Title on own line)
   Date + Severity + Icon row below
   ================================ */

.afw-item-header-row {
  display: flex;
  flex-direction: column; /* title then meta row */
  align-items: stretch;
  gap: 6px;
}

.afw-item-title {
  font-weight: 700;
  color: #0f174f;
}

/* Second row: left group + right icon */
.afw-item-header-right {
  display: flex;
  align-items: center;
  justify-content: space-between; /* pushes icon far right */
  width: 100%;
  gap: 12px;
}

/* Left group: date + severity */
.afw-item-meta-severity {
  display: flex;
  align-items: center;
  gap: 10px;
}

/* Date */
.afw-item-meta {
  font-size: 12px;
  color: #6b7280;
}

/* Body text */
.afw-item-body {
  margin-top: 8px;
  color: #374151;
  font-size: 17px;
  line-height: 1.4;
}

/* Icon "mark read" button */
.afw-markread-icon {
  width: 28px;
  height: 28px;
  border-radius: 6px;
  border: 1px solid rgba(226, 82, 15, 0.35);
  background: rgba(226, 82, 15, 0.08);
  color: #e2520f;
  font-size: 14px;
  font-weight: 700;

  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}

.afw-markread-icon:hover:not(:disabled) {
  background: rgba(226, 82, 15, 0.18);
  transform: scale(1.05);
}

.afw-markread-icon:disabled {
  opacity: 0.8;
  cursor: default;
}

/* When read */
.afw-read-icon {
  background: #e2520f;
  color: white;
  border-color: #e2520f;
  cursor: default;
}

/* Severity pill (button-like, not clickable) */
.afw-severity-btn {
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 11px;
  font-weight: 600;
  border: 1px solid transparent;
  cursor: default;
  -webkit-user-select: none;
          user-select: none;
  line-height: 1.2;
  text-transform: uppercase;
}

/* INFO */
.afw-severity-info {
  background: rgba(59, 130, 246, 0.12);
  color: #1d4ed8;
  border-color: rgba(59, 130, 246, 0.25);
}

/* WARNING */
.afw-severity-warning {
  background: rgba(245, 158, 11, 0.14);
  color: #b45309;
  border-color: rgba(245, 158, 11, 0.28);
}

/* CRITICAL */
.afw-severity-critical {
  background: rgba(239, 68, 68, 0.12);
  color: #b91c1c;
  border-color: rgba(239, 68, 68, 0.25);
}

/* ================================
   Inline mode (navbar placement)
   ================================ */

.afw-inline {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.afw-button-inline {
  width: 36px;
  height: 36px;
  border-radius: 6px;
  background: transparent;
  color: #0f174f;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
}

.afw-inline .afw-badge {
  top: -6px;
  right: -6px;
  background: #e65c1c;
  color: white;
  font-size: 11px;
  padding: 2px 5px;
}

/* Fixed dropdown panel for inline mode */
.afw-panel-inline {
  position: fixed;
  right: 20px;
  top: 64px;
  width: min(420px, calc(100vw - 40px));
  max-width: calc(100vw - 40px);
  transform-origin: top right;
  box-shadow: 0 10px 30px rgba(2, 6, 23, 0.2);
  z-index: 1500;

  /* keep same base panel behaviour */
  background: white;
  border-radius: 12px;
  max-height: calc(100vh - 120px);
  overflow: hidden;
}

/* Mobile adjustments */
@media (max-width: 480px) {
  .afw-panel {
    width: calc(100vw - 24px);
  }
  .afw-button {
    width: 48px;
    height: 48px;
  }
}

/* Compact dropdown behaviour on small screens */
@media (max-width: 640px) {
  .afw-panel-inline {
    left: 12px;
    right: 12px;
    top: 64px;
    width: auto;
    max-width: calc(100vw - 24px);
    border-radius: 10px;
    max-height: 60vh;
    overflow: hidden;
    z-index: 1400;
  }

  .afw-panel-inline .afw-panel-body {
    max-height: calc(60vh - 64px);
  }

  .afw-action,
  .afw-close {
    padding: 10px;
  }
}

@media (max-width: 380px) {
  .afw-panel {
    width: calc(100vw - 24px);
    max-height: calc(100vh - 100px);
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/AnnouncementsFloatingWidget.css"],"names":[],"mappings":"AAAA;;;qCAGqC;;AAErC,sCAAsC;AACtC;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;AACtB;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,eAAe;EACf,kBAAkB;AACpB;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,UAAU;AACV;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;EAC3C,mBAAmB;;EAEnB,8BAA8B;EAC9B,oDAAoD;EACpD,UAAU;EACV,uCAAuC;EACvC,oBAAoB;;EAEpB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,+BAA+B;EAC/B,cAAc;EACd,aAAa;EACb,iCAAiC;AACnC;;AAEA;;EAEE,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA,SAAS;AACT;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,wBAAwB;AACxB;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;;;qCAGqC;;AAErC;EACE,aAAa;EACb,sBAAsB,EAAE,wBAAwB;EAChD,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B,EAAE,0BAA0B;EAC1D,WAAW;EACX,SAAS;AACX;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,SAAS;AACT;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yCAAyC;EACzC,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;;EAEhB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA,+CAA+C;AAC/C;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA,YAAY;AACZ;EACE,oCAAoC;EACpC,cAAc;EACd,sCAAsC;AACxC;;AAEA,aAAa;AACb;EACE,mCAAmC;EACnC,cAAc;EACd,qCAAqC;AACvC;;AAEA;;qCAEqC;;AAErC;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,eAAe;EACf,WAAW;EACX,SAAS;EACT,qCAAqC;EACrC,6BAA6B;EAC7B,2BAA2B;EAC3B,2CAA2C;EAC3C,aAAa;;EAEb,mCAAmC;EACnC,iBAAiB;EACjB,mBAAmB;EACnB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA,gDAAgD;AAChD;EACE;IACE,UAAU;IACV,WAAW;IACX,SAAS;IACT,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,yBAAyB;IACzB,+BAA+B;EACjC;AACF","sourcesContent":["/* ================================\r\n   Announcements Floating Widget\r\n   (Clean version: no duplicates)\r\n   ================================ */\r\n\r\n/* Floating container (bottom-right) */\r\n.afw-container {\r\n  position: fixed;\r\n  right: 20px;\r\n  bottom: 20px;\r\n  z-index: 1200;\r\n  font-family: inherit;\r\n}\r\n\r\n/* Floating button */\r\n.afw-button {\r\n  width: 56px;\r\n  height: 56px;\r\n  border-radius: 999px;\r\n  background: #0f174f;\r\n  color: white;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  box-shadow: 0 6px 18px rgba(15, 23, 79, 0.25);\r\n  cursor: pointer;\r\n  position: relative;\r\n}\r\n\r\n/* Badge (unread count) */\r\n.afw-badge {\r\n  position: absolute;\r\n  top: -6px;\r\n  right: -6px;\r\n  background: #e65c1c;\r\n  color: white;\r\n  font-size: 12px;\r\n  padding: 3px 6px;\r\n  border-radius: 999px;\r\n}\r\n\r\n/* Panel */\r\n.afw-panel {\r\n  width: min(420px, calc(100vw - 40px));\r\n  max-width: calc(100vw - 32px);\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 12px 40px rgba(2, 6, 23, 0.4);\r\n  margin-bottom: 12px;\r\n\r\n  transform-origin: bottom right;\r\n  transition: transform 180ms ease, opacity 180ms ease;\r\n  opacity: 0;\r\n  transform: scale(0.95) translateY(10px);\r\n  pointer-events: none;\r\n\r\n  max-height: calc(100vh - 120px);\r\n  overflow: hidden;\r\n  z-index: 1300;\r\n}\r\n\r\n.afw-open .afw-panel {\r\n  opacity: 1;\r\n  transform: scale(1) translateY(0);\r\n  pointer-events: auto;\r\n}\r\n\r\n/* Panel header */\r\n.afw-panel-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 12px 14px;\r\n  border-bottom: 1px solid #eef2f6;\r\n}\r\n\r\n.afw-actions {\r\n  display: flex;\r\n  gap: 8px;\r\n  align-items: center;\r\n}\r\n\r\n.afw-action {\r\n  background: none;\r\n  border: none;\r\n  padding: 6px 8px;\r\n  border-radius: 6px;\r\n  cursor: pointer;\r\n}\r\n\r\n.afw-close {\r\n  background: none;\r\n  border: none;\r\n  font-size: 14px;\r\n  padding: 6px 8px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Panel body */\r\n.afw-panel-body {\r\n  max-height: calc(100vh - 200px);\r\n  overflow: auto;\r\n  padding: 12px;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.afw-empty,\r\n.afw-error {\r\n  color: #6b7280;\r\n  padding: 16px;\r\n  text-align: center;\r\n}\r\n\r\n/* List */\r\n.afw-list {\r\n  list-style: none;\r\n  margin: 0;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 12px;\r\n}\r\n\r\n/* Item card */\r\n.afw-item {\r\n  background: #f8fafc;\r\n  border-radius: 8px;\r\n  padding: 10px;\r\n  border: 1px solid #eef2f6;\r\n}\r\n\r\n/* Read / Unread state */\r\n.afw-unread {\r\n  border: 2px solid #e2520f;\r\n}\r\n\r\n.afw-read {\r\n  opacity: 0.7;\r\n  border-left: 3px solid transparent;\r\n}\r\n\r\n/* ================================\r\n   ITEM LAYOUT (Title on own line)\r\n   Date + Severity + Icon row below\r\n   ================================ */\r\n\r\n.afw-item-header-row {\r\n  display: flex;\r\n  flex-direction: column; /* title then meta row */\r\n  align-items: stretch;\r\n  gap: 6px;\r\n}\r\n\r\n.afw-item-title {\r\n  font-weight: 700;\r\n  color: #0f174f;\r\n}\r\n\r\n/* Second row: left group + right icon */\r\n.afw-item-header-right {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between; /* pushes icon far right */\r\n  width: 100%;\r\n  gap: 12px;\r\n}\r\n\r\n/* Left group: date + severity */\r\n.afw-item-meta-severity {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n}\r\n\r\n/* Date */\r\n.afw-item-meta {\r\n  font-size: 12px;\r\n  color: #6b7280;\r\n}\r\n\r\n/* Body text */\r\n.afw-item-body {\r\n  margin-top: 8px;\r\n  color: #374151;\r\n  font-size: 17px;\r\n  line-height: 1.4;\r\n}\r\n\r\n/* Icon \"mark read\" button */\r\n.afw-markread-icon {\r\n  width: 28px;\r\n  height: 28px;\r\n  border-radius: 6px;\r\n  border: 1px solid rgba(226, 82, 15, 0.35);\r\n  background: rgba(226, 82, 15, 0.08);\r\n  color: #e2520f;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n  padding: 0;\r\n}\r\n\r\n.afw-markread-icon:hover:not(:disabled) {\r\n  background: rgba(226, 82, 15, 0.18);\r\n  transform: scale(1.05);\r\n}\r\n\r\n.afw-markread-icon:disabled {\r\n  opacity: 0.8;\r\n  cursor: default;\r\n}\r\n\r\n/* When read */\r\n.afw-read-icon {\r\n  background: #e2520f;\r\n  color: white;\r\n  border-color: #e2520f;\r\n  cursor: default;\r\n}\r\n\r\n/* Severity pill (button-like, not clickable) */\r\n.afw-severity-btn {\r\n  padding: 4px 10px;\r\n  border-radius: 8px;\r\n  font-size: 11px;\r\n  font-weight: 600;\r\n  border: 1px solid transparent;\r\n  cursor: default;\r\n  user-select: none;\r\n  line-height: 1.2;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* INFO */\r\n.afw-severity-info {\r\n  background: rgba(59, 130, 246, 0.12);\r\n  color: #1d4ed8;\r\n  border-color: rgba(59, 130, 246, 0.25);\r\n}\r\n\r\n/* WARNING */\r\n.afw-severity-warning {\r\n  background: rgba(245, 158, 11, 0.14);\r\n  color: #b45309;\r\n  border-color: rgba(245, 158, 11, 0.28);\r\n}\r\n\r\n/* CRITICAL */\r\n.afw-severity-critical {\r\n  background: rgba(239, 68, 68, 0.12);\r\n  color: #b91c1c;\r\n  border-color: rgba(239, 68, 68, 0.25);\r\n}\r\n\r\n/* ================================\r\n   Inline mode (navbar placement)\r\n   ================================ */\r\n\r\n.afw-inline {\r\n  position: relative;\r\n  display: inline-flex;\r\n  align-items: center;\r\n}\r\n\r\n.afw-button-inline {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 6px;\r\n  background: transparent;\r\n  color: #0f174f;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  position: relative;\r\n}\r\n\r\n.afw-inline .afw-badge {\r\n  top: -6px;\r\n  right: -6px;\r\n  background: #e65c1c;\r\n  color: white;\r\n  font-size: 11px;\r\n  padding: 2px 5px;\r\n}\r\n\r\n/* Fixed dropdown panel for inline mode */\r\n.afw-panel-inline {\r\n  position: fixed;\r\n  right: 20px;\r\n  top: 64px;\r\n  width: min(420px, calc(100vw - 40px));\r\n  max-width: calc(100vw - 40px);\r\n  transform-origin: top right;\r\n  box-shadow: 0 10px 30px rgba(2, 6, 23, 0.2);\r\n  z-index: 1500;\r\n\r\n  /* keep same base panel behaviour */\r\n  background: white;\r\n  border-radius: 12px;\r\n  max-height: calc(100vh - 120px);\r\n  overflow: hidden;\r\n}\r\n\r\n/* Mobile adjustments */\r\n@media (max-width: 480px) {\r\n  .afw-panel {\r\n    width: calc(100vw - 24px);\r\n  }\r\n  .afw-button {\r\n    width: 48px;\r\n    height: 48px;\r\n  }\r\n}\r\n\r\n/* Compact dropdown behaviour on small screens */\r\n@media (max-width: 640px) {\r\n  .afw-panel-inline {\r\n    left: 12px;\r\n    right: 12px;\r\n    top: 64px;\r\n    width: auto;\r\n    max-width: calc(100vw - 24px);\r\n    border-radius: 10px;\r\n    max-height: 60vh;\r\n    overflow: hidden;\r\n    z-index: 1400;\r\n  }\r\n\r\n  .afw-panel-inline .afw-panel-body {\r\n    max-height: calc(60vh - 64px);\r\n  }\r\n\r\n  .afw-action,\r\n  .afw-close {\r\n    padding: 10px;\r\n  }\r\n}\r\n\r\n@media (max-width: 380px) {\r\n  .afw-panel {\r\n    width: calc(100vw - 24px);\r\n    max-height: calc(100vh - 100px);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
